export const BNB_ID = 1;
export const USDT_ID = 2;
export const BTC_ID = 3;
export const ETH_ID = 4;
